import { usd } from '@/lib/money'
import { cn } from '@/lib/utils'
import { Won } from './Won'

/** A dollar figure in the text colour: "$1,234.56", "−$1.23". With `hidden`
 *  it is a dash instead — spend that cannot come in (Google Ads refused or not
 *  linked) is not $0.00. `hint` (why) goes to screen readers only: each
 *  screen says the reason once, at its head, not on every dash. With `krw`
 *  (revenue) the won figure sits under it, small and muted, once the shell
 *  has a rate. */
export function Money({ value, hidden, hint, krw, className }: { value: number | null | undefined; hidden?: boolean; hint?: string | null; krw?: boolean; className?: string }) {
  if (hidden) {
    return (
      <span className={cn('tabular-nums text-muted-foreground', className)}>
        —{hint && <span className="sr-only"> {hint}</span>}
      </span>
    )
  }
  if (krw) {
    return (
      <span className={cn('inline-flex flex-col', className)}>
        <span className="whitespace-nowrap tabular-nums">{usd(value)}</span>
        <Won usd={value} className="text-meta font-normal" />
      </span>
    )
  }
  return <span className={cn('whitespace-nowrap tabular-nums', className)}>{usd(value)}</span>
}
